import { render, staticRenderFns } from "./role-edit.vue?vue&type=template&id=70510718&scoped=true&"
import script from "./role-edit.vue?vue&type=script&lang=js&"
export * from "./role-edit.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/i-switch.less?vue&type=style&index=0&id=70510718&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70510718",
  null
  
)

component.options.__file = "role-edit.vue"
export default component.exports